import { translate } from "../../../providers";

export const translateSortAlgorithm = (value) => translate(`common:search.sort-algorithms.${value?.toLowerCase()}`);
export const translateSortByAlgorithm = (value) =>
	translate(`common:search.sort-algorithms.${value?.toLowerCase()}.sorting`);
